/**
 * Statuts des réservations, tels que les écrit l'application mobile dans la
 * collection `reservations`. Le site les lit et les affiche à l'identique.
 *
 * Cycle de vie : en_attente → accepte → arrive → payee → terminee
 * `arrive` est posé par le Smart à son arrivée et déclenche une Cloud Function.
 */

export const BOOKING_STATUSES = ['en_attente', 'accepte', 'arrive', 'payee', 'terminee'];

export const STATUS_LABELS = {
  en_attente: 'En attente',
  accepte: 'Acceptée',
  arrive: 'Smart arrivé',
  payee: 'Payée',
  terminee: 'Terminée',
};

const STATUS_COLORS = {
  en_attente: 'bg-yellow-500/10 text-yellow-500 border border-yellow-500/20',
  accepte: 'bg-blue-500/10 text-blue-500 border border-blue-500/20',
  arrive: 'bg-purple-500/10 text-purple-500 border border-purple-500/20',
  payee: 'bg-emerald-500/10 text-emerald-500 border border-emerald-500/20',
  terminee: 'bg-green-500/10 text-green-500 border border-green-500/20',
};

export const statusLabel = (statut) => STATUS_LABELS[statut] || statut || '—';

export const statusColor = (statut) =>
  STATUS_COLORS[statut] || 'bg-[#252525] text-[#AAAAAA]';

/** Une prestation close, au sens du client comme du Smart. */
export const isClosed = (statut) => ['payee', 'terminee'].includes(statut);

/** Formate une date renvoyée par l'API (chaîne ISO) en français. */
export const formatDate = (value, withTime = false) => {
  if (!value) return 'Date à définir';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Date à définir';

  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  });
};

/** Le budget est stocké en chaîne par l'appli : on l'affiche proprement. */
export const formatBudget = (budget) => {
  if (!budget) return '—';
  const amount = Number(String(budget).replace(/\s/g, ''));
  return Number.isNaN(amount) ? `${budget} FCFA` : `${amount.toLocaleString('fr-FR')} FCFA`;
};
